import { createSlice } from '@reduxjs/toolkit';
import { ReducerStatus } from 'utils/constants';
import { getUserProfile, updateUserProfile } from './user-action';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    userProfile: {
      data: null,
      modal: false,
      status: ReducerStatus.IDLE,
      error: null,
    },
    userProfilePopup: {
      modal: false,
    },
    updateUserProfile: {
      data: null,
      modal: false,
      status: ReducerStatus.IDLE,
      error: null,
    },
  },
  reducers: {
    setUserProfile(state, action) {
      state.userProfile = {
        ...state.userProfile,
        ...action.payload,
      };
    },
    setUserProfilePopup(state, action) {
      state.userProfilePopup = {
        ...state.userProfilePopup,
        ...action.payload,
      };
    },
    setUpdateUserProfle(state, action) {
      state.updateUserProfile = {
        ...state.updateUserProfile,
        ...action.payload,
      };
    },
  },
  extraReducers(builder) {
    builder
      // Fetch User Profile
      .addCase(getUserProfile.pending, (state) => {
        state.userProfile.status = ReducerStatus.LOADING;
        state.userProfile.error = null;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.userProfile.status = ReducerStatus.SUCCEEDED;
        state.userProfile.data = action.payload;
        state.userProfile.error = null;
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.userProfile.status = ReducerStatus.FAILED;
        state.userProfile.error = action.payload;
      })
      // Update User Profile
      .addCase(updateUserProfile.pending, (state) => {
        state.updateUserProfile.status = ReducerStatus.LOADING;
        state.updateUserProfile.error = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.updateUserProfile.status = ReducerStatus.SUCCEEDED;
        state.updateUserProfile.data = action.payload;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.updateUserProfile.status = ReducerStatus.FAILED;
        state.updateUserProfile.error = action.payload;
      });
  },
});

export const userActions = userSlice.actions;
export default userSlice;
